import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {UploadStyle} from './../../styles'
export default class UploadFile extends Component {
  state = {

  }

  handlerChange = (e) => {
    const file = e.currentTarget.files[0]
    this.props.uploadCallback(file)
  }
  
  defaultProps = {
    name: 'upload-file',
    id: 'upload-file',
  }

  render () {
    const { children, name, id, accept, value} = this.props
    return (
      <div className={` upload ${UploadStyle}`}>
        <input type="file" name={name} id={id} defaultValue={value} onChange={this.handlerChange} accept={accept} />
        <label htmlFor={id}> { children } </label>
      </div>
    )
  }
}

UploadFile.propTypes = {
  name: PropTypes.string,
  id:  PropTypes.string,
}


// WEBPACK FOOTER //
// ./src/components/Form/UploadFile.js